import { useTranslation } from "react-i18next";
import { Sun, Moon, Monitor } from "lucide-react";
import { useTheme, type Theme } from "@/hooks/useTheme";

const themeIcons: Record<Theme, typeof Sun> = {
  light: Sun,
  dark: Moon,
  system: Monitor,
};

const themeOrder: Theme[] = ["light", "dark", "system"];

/**
 * Theme toggle button — cycles through light → dark → system.
 *
 * Extracted from AuthLayout and DashboardShell to avoid duplication.
 */
export function ThemeToggle() {
  const { t } = useTranslation();
  const { theme, setTheme } = useTheme();

  const nextTheme = themeOrder[(themeOrder.indexOf(theme) + 1) % themeOrder.length];
  const ThemeIcon = themeIcons[theme];

  return (
    <button
      type="button"
      onClick={() => setTheme(nextTheme)}
      className="flex h-9 w-9 items-center justify-center rounded-lg text-muted transition-colors hover:bg-elevated hover:text-heading"
      aria-label={t(`theme.${nextTheme}`)}
      title={t(`theme.${theme}`)}
    >
      <ThemeIcon size={18} />
    </button>
  );
}
